type localesKeys__VisibilityToggles = {
    VisibilityToggles__HeaderLabel: string;
    VisibilityToggles__ProjectsLabel: string;
    VisibilityToggles__AchievementsLabel: string;
    VisibilityToggles__ResponsibilitiesLabel: string;
}

const ruLocale__VisibilityToggles: localesKeys__VisibilityToggles = {
    VisibilityToggles__HeaderLabel: 'Показать:',
    VisibilityToggles__ProjectsLabel: 'Проекты',
    VisibilityToggles__AchievementsLabel: 'Достижения',
    VisibilityToggles__ResponsibilitiesLabel: 'Ответственность'
};

const enLocale__VisibilityToggles: localesKeys__VisibilityToggles = {
    VisibilityToggles__HeaderLabel: 'Show:',
    VisibilityToggles__ProjectsLabel: 'Projects',
    VisibilityToggles__AchievementsLabel: 'Achievements',
    VisibilityToggles__ResponsibilitiesLabel: 'Responsibilities'
};

export { ruLocale__VisibilityToggles, enLocale__VisibilityToggles };
export type { localesKeys__VisibilityToggles };